import { useState, useEffect } from 'react';
import { fetchDataAuthenticated } from '../utilities/HttpUtils';

import useAlert from '../Components/Alerts/useAlert';

export function useListActiveDirectoryGroups() {
    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const [loading, setLoading] = useState(true);

    const [activeDirectoryGroups, setActiveDirectoryGroups] = useState();

    const { setAlert } = useAlert();

    useEffect(() => {
        getActiveDirectoryGroups();
    }, []);

    async function getActiveDirectoryGroups () {
        await fetchDataAuthenticated(_apiUrl + `api/user/ActiveDirectoryGroups`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setActiveDirectoryGroups(data);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return { activeDirectoryGroups, loading };
}
